import type { SafetyRepMissing } from '../../api/workEnvironmentTypes';

/*
 * Who acts as safety representative for the team is decided in the API. What is here picks the
 * texts for when no one does, as when the team leader is the only one who represents the team.
 */

const MISSING_SUFFIX: Record<SafetyRepMissing, string> = {
  noSafetyRep: 'NoRep',
  leaderIsSafetyRep: 'LeaderIsRep',
  notUsed: '',
};

/** The ending of the text keys, with nothing added when someone acts as safety representative */
export const missingSuffix = (missing: SafetyRepMissing | null) => (missing ? MISSING_SUFFIX[missing] : '');
